// ajp-postcode-validator.js

document.addEventListener("DOMContentLoaded", function () {
  // The add-to-cart button you've tagged
  const addToCartButton = document.querySelector("button.validate-custom-fields");
  if (!addToCartButton) {
    console.debug("[postcode validator] no add-to-cart button found");
    return;
  }

  // Postcode field – can live *outside* the form, so don't scope to the form
  const postcodeField = document.querySelector('input[data-validate-ni-postcode="true"]');
  if (!postcodeField) {
    console.debug("[postcode validator] no postcode field found");
    return;
  }

  // Associated error element (from aria-describedby)
  let errorEl = null;
  const errorId = postcodeField.getAttribute("aria-describedby");
  if (errorId) {
    errorEl = document.getElementById(errorId);
  }

  function clearPostcodeError() {
    postcodeField.classList.remove("tw-border-red-600");
    if (errorEl) errorEl.classList.add("tw-hidden");
  }

  function showPostcodeError() {
    postcodeField.classList.add("tw-border-red-600");
    if (errorEl) errorEl.classList.remove("tw-hidden");
    postcodeField.focus();
  }

  function isBlockedPostcode(raw) {
    if (!raw) return false;
    // Strip spaces and normalise case
    const normalised = raw.replace(/\s+/g, "").toUpperCase();
    // Block anything starting with BT (e.g. "BT93 8AD", " bt5 1xx ", etc.)
    return normalised.startsWith("BT");
  }

  // Validate on click of add-to-cart
  addToCartButton.addEventListener("click", function (event) {
    clearPostcodeError();

    const value = postcodeField.value || "";
    if (isBlockedPostcode(value)) {
      console.debug("[postcode validator] blocked NI postcode:", value);

      // Stop the form submission AND any other click handlers (e.g. theme JS)
      event.preventDefault();
      event.stopImmediatePropagation();

      showPostcodeError();
    }
    // If postcode is allowed, do nothing – other validation & Shopify JS continue as normal
  });
});
